// Client-side "recently viewed" strip powered by localStorage.
// Stores a small array of { slug, title, hero_image, published_at, read_minutes }
// so the blog index can show a returning reader what they've dipped into.
const KEY = "bb.recentlyViewed.v1";
const MAX = 6;

function safeParse() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function getRecentlyViewed() {
  if (typeof window === "undefined") return [];
  return safeParse();
}

export function recordViewed(post) {
  if (typeof window === "undefined" || !post || !post.slug) return;
  const entry = {
    slug: post.slug,
    title: post.title,
    hero_image: post.hero_image || "",
    published_at: post.published_at || "",
    read_minutes: post.read_minutes || 0,
    viewed_at: new Date().toISOString(),
  };
  const current = safeParse().filter((p) => p.slug !== post.slug);
  const next = [entry, ...current].slice(0, MAX);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* quota errors — ignore */
  }
}

export function clearRecentlyViewed() {
  try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
